export default "__VITE_ASSET__d1_vNwG7__"